export const environment = {
  production: true,
  mockup: false,

  CPS2_DOMAIN: 'https://cps-preprod.pharmacists.ca/',
  CPHA_AUTH_ENDPOINT: 'https://hub-preprod.pharmacists.ca/cpha-auth',
  COMMONS_API_ENDPOINT: 'https://hub-preprod.pharmacists.ca/cpha-commons-rest-ws',
  CPS_URL: 'https://cps2-preprod.pharmacists.ca/token-receiver',
  CPS_ORIGIN: 'https://cps-preprod.pharmacists.ca'
};
